import React from 'react';
import { useModelVersionControl } from '../../../hooks/useModelVersionControl';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { modelList } from '../../../utils';

const ModelVersionInput: React.FC = () => {
  const { value, toggleVersion } = useModelVersionControl('2.0');
  const matchedModelDisplayName = modelList.find((i) => i.version === value)?.displayName;

  return (
    <div
      className="flex flex-col"
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <span className="text-[10px] text-[#9D9DA6] uppercase text-right">Model</span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <span
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleVersion();
                return false;
              }}
              className="underline cursor-pointer select-none text-[#9D9DA6] hover:text-jen-orange transition-colors"
            >
              {matchedModelDisplayName && matchedModelDisplayName.length > 5
                ? `${matchedModelDisplayName.slice(0, 5)}...`
                : `${matchedModelDisplayName}`}
            </span>
          </TooltipTrigger>
          <TooltipContent className="text-[#9D9DA6] bg-zinc-800 border-zinc-700">{value}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};

export default ModelVersionInput;
